import React, { useEffect, useState } from 'react'
import { user } from "../join/Join"
import socketIo from "socket.io-client"
import "./Chat.css"
import Message from "../message/Message"
import ReactScrollToBottom from "react-scroll-to-bottom"
import closeIcon from "../images/closeIcon.png"

const ENDPOINT = "https://chatappbackend-production-f3d1.up.railway.app/";
// sachin 
let socket
const Chat = () => {

    const [id, setId] = useState("")
    const [messages, setMessages] = useState([])

    const send = () => {
        const message = document.getElementById('chatInput').value;
        socket.emit('message', { message, id })
        document.getElementById('chatInput').value = '';
    }
    useEffect(() => {
        socket = socketIo(ENDPOINT, { transports: ['websocket'] })

        socket.on('connect', () => {
            setId(socket.id)
        })
        socket.emit('joined', { user })

        socket.on('welcome', (data) => {
            setMessages([...messages, data])
            console.log(data.user, data.message)
        })




        return () => {
            socket.disconnect()
            socket.off()
        }
    }, [])

    useEffect(() => {
        socket.on('sendMessage', (data) => {
            setMessages([...messages, data])
            console.log(data.user, data.message, data.id)
        })
        socket.on('userJoined', (data) => {
            setMessages([...messages, data])
            console.log(data.user, data.message)
        })
        socket.on('leave', (data) => {
            setMessages([...messages, data])
            console.log(data.user, data.message)
        })
        return () => {
            socket.off()
        }
    }, [messages])


    return (
        <div className='chatPage'>
            <div className="chatContainer" >
                <div className="header">
                    <h2>Sachin Chat App</h2>
                    <a href="/"><img src={closeIcon} alt="close" /></a>
                </div>
                <ReactScrollToBottom className="chatBox">
                    {messages.map((item, i) => <Message user={item.id === id ? '' : item.user} message={item.message} classs={item.id === id ? 'right' : 'left'} />)}
                </ReactScrollToBottom>

                <div className='inputBox'>
                    <input onKeyPress={(event) => event.key === 'Enter' ? send() : null} type="text" id='chatInput' />
                    <input onClick={send} type="submit" value="Send" className='sendBtn' />
                </div>

            </div>
        </div>
    )
}

export default Chat
